// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mobile-stream-view[data-v-e2f6dbb2]{pointer-events:auto;height:calc(100% - 56.25vw);min-height:calc(500px - 56.25vw)!important;overflow-y:auto;display:flex;flex-direction:column;border-radius:0;padding:0;background:#fff}.mobile-stream-view .event-top__chat[data-v-e2f6dbb2]{flex:1}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
